import { render, staticRenderFns } from "./BubbleListFooter.vue?vue&type=template&id=4cb2be48&scoped=true"
import script from "./BubbleListFooter.vue?vue&type=script&lang=js"
export * from "./BubbleListFooter.vue?vue&type=script&lang=js"
import style0 from "./BubbleListFooter.vue?vue&type=style&index=0&id=4cb2be48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___1b8eefb4ee358cb3b2239f0224d67603/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2be48",
  null
  
)

export default component.exports